import {PlayersList as NBAClassicPlayersList} from 'components/organisms/used-players-list/components/desktop/players-list/sports/nba/classic';
import {PlayersList as NBAShowDownPlayersList} from 'components/organisms/used-players-list/components/desktop/players-list/sports/nba/showdown';
import {PlayersList as NBATiersPlayersList} from 'components/organisms/used-players-list/components/desktop/players-list/sports/nba/tiers';

import {PlayersList as MLBClassicPlayersList} from 'components/organisms/used-players-list/components/desktop/players-list/sports/mlb/classic';
import {PlayersList as MLBShowDownPlayersList} from 'components/organisms/used-players-list/components/desktop/players-list/sports/mlb/showdown';
import {PlayersList as MLBTiersPlayersList} from 'components/organisms/used-players-list/components/desktop/players-list/sports/mlb/tiers';

import {PlayersList as CFBClassicPlayersList} from 'components/organisms/used-players-list/components/desktop/players-list/sports/cfb/classic';
import {PlayersList as CFBShowDownPlayersList} from 'components/organisms/used-players-list/components/desktop/players-list/game-types/showdown';

import {PlayersList as NHLClassicPlayersList} from 'components/organisms/used-players-list/components/desktop/players-list/sports/nhl/classic';
import {PlayersList as NHLShowDownPlayersList} from 'components/organisms/used-players-list/components/desktop/players-list/sports/nhl/showdown';
import {PlayersList as NHLTiersPlayersList} from 'components/organisms/used-players-list/components/desktop/players-list/sports/nhl/tiers';

import {PlayersList as NFLClassicPlayersList} from 'components/organisms/used-players-list/components/desktop/players-list/sports/nfl/classic';
import {PlayersList as NFLShowDownPlayersList} from 'components/organisms/used-players-list/components/desktop/players-list/sports/nfl/showdown';
import {PlayersList as NFLTiersPlayersList} from 'components/organisms/used-players-list/components/desktop/players-list/sports/nfl/tiers';

import {PlayersList as NASCARPlayersList} from 'components/organisms/used-players-list/components/desktop/players-list/sports/nascar/classic';

import {PlayersList as GOLFClassicPlayersList} from 'components/organisms/used-players-list/components/desktop/players-list/game-types/classic';
import {PlayersList as GOLFTiersPlayersList} from 'components/organisms/used-players-list/components/desktop/players-list/sports/golf/tiers';

import {PlayersList as MMAClassicPlayersList} from 'components/organisms/used-players-list/components/desktop/players-list/sports/mma/classic';
import {PlayersList as MMAShowDownPlayersList} from 'components/organisms/used-players-list/components/desktop/players-list/sports/mma/showdown';
import {PlayersList as LOLPlayersList} from 'components/organisms/used-players-list/components/desktop/players-list/sports/lol/classic';
import {PlayersList as TennisClassicPlayersList} from 'components/organisms/used-players-list/components/desktop/players-list/sports/tennis/classic';
import {PlayersList as F1PlayersList} from 'components/organisms/used-players-list/components/desktop/players-list/sports/f1/classic';
import Const from 'constants';

const classesMap = {
    [Const.LEAGUE_CFB]: {
        [Const.GAME_TYPE_CLASSIC]: CFBClassicPlayersList,
        [Const.GAME_TYPE_SHOWDOWN]: CFBShowDownPlayersList,
    },
    [Const.LEAGUE_F1]: {
        [Const.GAME_TYPE_CLASSIC]: F1PlayersList,
    },
    [Const.LEAGUE_GOLF]: {
        [Const.GAME_TYPE_CLASSIC]: GOLFClassicPlayersList,
        [Const.GAME_TYPE_SHOWDOWN]: GOLFClassicPlayersList,
        [Const.GAME_TYPE_TIERS]: GOLFTiersPlayersList,
    },
    [Const.LEAGUE_LOL]: {
        [Const.GAME_TYPE_CLASSIC]: LOLPlayersList,
    },
    [Const.LEAGUE_MMA]: {
        [Const.GAME_TYPE_CLASSIC]: MMAClassicPlayersList,
        [Const.GAME_TYPE_SHOWDOWN]: MMAShowDownPlayersList,
    },
    [Const.LEAGUE_MLB]: {
        [Const.GAME_TYPE_CLASSIC]: MLBClassicPlayersList,
        [Const.GAME_TYPE_SHOWDOWN]: MLBShowDownPlayersList,
        [Const.GAME_TYPE_TIERS]: MLBTiersPlayersList,
    },
    [Const.LEAGUE_NASCAR]: {
        [Const.GAME_TYPE_CLASSIC]: NASCARPlayersList,
    },
    [Const.LEAGUE_NBA]: {
        [Const.GAME_TYPE_CLASSIC]: NBAClassicPlayersList,
        [Const.GAME_TYPE_SHOWDOWN]: NBAShowDownPlayersList,
        [Const.GAME_TYPE_TIERS]: NBATiersPlayersList,
    },
    [Const.LEAGUE_NFL]: {
        [Const.GAME_TYPE_CLASSIC]: NFLClassicPlayersList,
        [Const.GAME_TYPE_SHOWDOWN]: NFLShowDownPlayersList,
        [Const.GAME_TYPE_TIERS]: NFLTiersPlayersList,
    },
    [Const.LEAGUE_NHL]: {
        [Const.GAME_TYPE_CLASSIC]: NHLClassicPlayersList,
        [Const.GAME_TYPE_SHOWDOWN]: NHLShowDownPlayersList,
        [Const.GAME_TYPE_TIERS]: NHLTiersPlayersList,
    },
    [Const.LEAGUE_TENNIS]: {
        [Const.GAME_TYPE_CLASSIC]: TennisClassicPlayersList,
    },
};

const Factory = {
    getComponent(sportConfig) {
        const sportName = sportConfig.getSport().toLowerCase();
        const gameType = sportConfig.getGameType().toLowerCase();

        const componentClass = classesMap[sportName]?.[gameType] ?? null;

        if (componentClass === null) {
            throw new Error(`Unsupported factory for "${sportName}", "${gameType}".`);
        }

        return componentClass;
    },
};

export {Factory};
